import ApplicationController from './application_controller'

export default class extends ApplicationController {
    static targets = [
        "lockId"
    ]

    async toggleBarcodeReader(e) {
        e.preventDefault();
        await this.showBarcodeReader(this.didScanListener);
    }

    didScanListener = async (barcode) => {
        this.stimulate(`SearchSecurityLockEventsComponent#search`, barcode.data);
    }

    onSubmit(e) {
        e.preventDefault();
    }

    onChangeLockId(e) {
        this.stimulate('SearchSecurityLockEventsComponent#search', this.lockIdTarget.value);
        this.lockIdTarget.value = "";
    }

    afterReflex(element, reflex, noop, reflexId) {
        this.showScannerFeedback(element);
        const focusElement = this.element.querySelector('[autofocus]');
        if (focusElement) {
            focusElement.focus();
        }
    }
}
